<!-- eslint-disable no-debugger -->
<!-- 全屏模态显示   公共大图阅读组件 -->
<template>
  <div>
    <div v-if="showModal" class="mask">
      <div class="mask mask_plus"></div>
      <div v-if="showLoad" id="img_loading">
        <img src="static/images/loading.gif" />
      </div>
      <div
        id="mask_close"
        @click="closeMask"
        class="el-icon-circle-close"
      ></div>
      <div
        id="toolPan"
        class="el-image-viewer__btn el-image-viewer__actions"
        style="width:420px;"
      >
        <div class="el-image-viewer__actions__inner" @mouseenter="checkHasOwnThisImgFun">
          <i @click="zoom(true)" class="el-icon-zoom-out"></i>
          <i @click="zoom(false)" class="el-icon-zoom-in"></i>
          <i @click="zoomReset()" class="el-icon-rank"></i>
          <i @click="xuanzhuan(0)" class="el-icon-refresh-left"></i>
          <i @click="xuanzhuan(1)" class="el-icon-refresh-right"></i>
          <!--
          <i @click="downImage()" class="el-icon-download"></i>
          <i @click="printImage" class="el-icon-printer"></i>
           -->
          <div class="dropdown">
            <i @click="setImage()" class="el-icon-setting dropbtn"></i>
            <div class="dropdown-content">
              <a @click="changeClass(1)">去 灰</a>
              <a @click="changeClass(2)">高 亮</a>
              <a @click="changeClass(3)">反 色</a>
              <!--
              <a @click="changeClass(4)">对比度</a>
              -->
              <a @click="changeClass(0)">还 原</a>
            </div>
          </div>
          <!--
          <el-tooltip
            class="item"
            effect="dark"
            :content="ownThisImg?'已收藏': '请您先添加收藏,再进行标注!'"
            placement="top"
          >
            <i @click="addNote()" class="el-icon-edit"></i>
          </el-tooltip>
          -->
        </div>
      </div>
      <div id="imgPan" :class="{gaoliang: glKey,huidu: hdKey,fanse: fsKey,duibidui: dbdKey}">
        <img id="bigImg" ref="bigImgObj" :src="imageSrc" @load="setImgSize" />
        <iframe id="iframeImgId" :src="imageSrc" frameborder="0" style="display: none;"></iframe>
      </div>
      <ul v-show="showFlags" id="flags">
        <li
          :id="i"
          v-for="(item, i) in noteList"
          :key="item.unId"
          @click="openTheNote(i)"
          class="flag el-icon-s-flag"
        ></li>
      </ul>
      <div id="imgInfoCanV" v-if="smallImgInfoShowState">
        <div id="imgInfoPan">
          <div id="iip1" class="infoDiv">
            <div id="iip_left">
              <img :src="srcImgUrl" alt="" />
            </div>
            <div id="iip_right">
              <div class="iip_right_t" id="iip_name">{{ imgName }}</div>
              <div class="iip_right_t">画师 {{ idraw }}</div>
              <div class="iip_right_t">刻工 {{ imark }}</div>
              <div class="iip_right_t titlespan">{{ isrc1 }}</div>
              <div class="iip_right_t titlespan">{{ isrc2 }}</div>
              <div class="iip_right_t titlespan">{{ isrc3 }}</div>
            </div>
          </div>
          <div class="infoDiv" id="lbinfo">{{ label }}</div>
        </div>
      </div>
    </div>
    <!--
    <notePan ref="notepan" @initNotesEvent="initNotes" @updateNoteEvent="updateNoteFromArray" @delNoteEvent="removeNoteFromArray"></notePan>
    -->
</div>
</template>

<script>
import config from '@/util/config.js'
// 调用外部js 文件里的函数 操作DOM {unId: 4, relY: 0, relX: 0, info: "edede"}
import { zoomAndDrag, suitToImgPan, zoomImage } from '@/util/tool2.js'
// import notePan from './modalRely/note'
const imgurl = '/md/front/paid/img/'
export default {
  data () {
    return {
      vueId: 'imageModal.vue',
      imgSrcLoadType: '0', // 原始图像加载方式 0：检索过来   1：从于都记忆和收藏夹跳过来
      isrc: '',
      isrc1: '',
      isrc2: '',
      isrc3: '',
      idraw: '',
      imark: '',
      label: '',
      srcImgUrl: '',
      showModal: false,
      xuzhuanTag: 0,
      showLoad: false,
      imgId: '',
      imgName: '',
      glKey: false, // 滤镜之高亮
      hdKey: false, // 滤镜之灰度
      fsKey: false, // 滤镜之反色
      dbdKey: false, // 滤镜之对比度
      noteList: [], // 签注列表
      penShow: false, // 加标注模式
      imgH: 0, // 原始图高
      imgW: 0, // 原始图宽
      imgRatio: 0.8, // 现在缩放后和原始大小的比例
      imageSrc: '', // 图像路径
      showFlags: false,
      notice: {
        imgLeft: 0, // 现在图像左距离
        imgTop: 0 // 现在图像距顶
      },
      smallImgInfoShowState: false,
      refreshTimeOutAddr: null,
      ownThisImg: false
    }
  },
  methods: {
    resetTopAndLeft (imgLeft, imgTop) {
      this.notice.imgLeft = imgLeft
      this.notice.imgTop = imgTop
    },
    refreshNotes () {
      return false
      // eslint-disable-next-line no-unreachable
      clearTimeout(this.refreshTimeOutAddr)
      this.refreshTimeOutAddr = setTimeout(() => { // 加了这个定时器后防止一直滚动滑轮出现批注旗子闪烁的情况(同时滑动图片的时候旗子更加自然)
        this.showFlags = false
        const alist = document.getElementsByClassName('flag')
        let x, y
        if (alist != null && alist.length > 0) {
          for (let i = 0; i < alist.length; i++) {
            const o = this.noteList[i]
            const obj = alist[i]
            x = o.relX * this.imgRatio + this.notice.imgLeft
            y = o.relY * this.imgRatio + this.notice.imgTop
            obj.style.left = x + 'px'
            obj.style.top = y + 'px'
          }
        }
        this.showFlags = true
      }, 500)
    },
    openTheNote (i) {
      const info = this.noteList[i]
      this.showOpNotePan(i, info)
    },
    showOpNotePan (index, objv) {
      // 打开更新或删除面板
      this.$refs.notepan.showOpNotePan(index, this.imgId, objv)
    },
    loadNotes () {
      this.$refs.notepan.showNotes(this.imgId)
    },
    initNotes (notelist) {
      this.noteList = notelist
      setTimeout(() => {
        this.refreshNotes() // 刷新位置
      }, 1000)
    },
    removeNoteFromArray (index) {
      this.noteList.splice(index, 1)
    },
    updateNoteFromArray (index, vstr) {
      this.noteList[index].info = vstr
    },
    addNote () {
      // 打开添加面板
      // this.$refs.bigImgObj.className = 'pen'
      this.$refs.bigImgObj.style.cursor = 'url("' + config.relatedPath() + 'static/images/shubiao.png"), auto'
      this.penShow = true
    },
    initNoteAndFlag (imgX, imgY) { // tool.js里面拖动函数有调用这个初始化方法(每次拖动都必须重新计算相对位置)
      // 画笔点击图片后触发
      this.$refs.notepan.showAddNotePan(this.imgId, imgX, imgY)
    },
    changeClass (id) {
      switch (id) {
        case 1:
          this.glKey = false
          this.hdKey = true
          this.fsKey = false
          this.dbdKey = false
          break
        case 2:
          this.glKey = true
          this.hdKey = false
          this.fsKey = false
          this.dbdKey = false
          break
        case 3:
          this.glKey = false
          this.hdKey = false
          this.fsKey = true
          this.dbdKey = false
          break
        case 4:
          this.glKey = false
          this.hdKey = false
          this.fsKey = false
          this.dbdKey = true
          break
        default:
          this.glKey = false
          this.hdKey = false
          this.fsKey = false
          this.dbdKey = false
      }
    },
    downImage () {
      const downurl = '/md/front/paid/down?id='
      let cmdstr = this.imgId + '&iname=' + this.imgName
      cmdstr = encodeURI(cmdstr)
      cmdstr = downurl + cmdstr + '&sun=' + Math.random()
      window.open(cmdstr, '_blank')
    },
    printImage () {
      // 之前使用的是一个vue2的打印插件, 打印的方法都是调用window或者iframe对象的系统打印方法
      const iframe = document.getElementById('iframeImgId')
      const doc = iframe.contentDocument
      doc.open()
      doc.write('<img src="' + this.imageSrc + '" style="height: 95vh; width: auto" />')
      doc.close()
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
    },
    setImage () {},
    closeMask () {
      this.$refs.bigImgObj.style.cursor = 'auto' // 关闭可能由于添加标签导致的鼠标样式
      this.showModal = false
      this.showLoad = false
      this.noteList = []
      this.$store.commit('flipCloseMaskState')
    },
    zoom (tag) {
      zoomImage(tag)
    },
    zoomReset () {
      this.showFlags = true
      this.xuzhuanTag = 0
      this.$refs.bigImgObj.style.transform = 'rotate(' + this.xuzhuanTag + 'deg)' // deg)后面绝对不能加分号, 否则旋转无效
      const oImg = this.$refs.bigImgObj
      const oParent = oImg.parentNode
      suitToImgPan(
        oParent.clientHeight,
        oParent.clientWidth,
        oImg.height,
        oImg.width,
        'bigImg',
        10,
        10
      )
    },
    xuanzhuan (id) {
      if (id === 1) {
        // 正转
        this.xuzhuanTag = this.xuzhuanTag + 90
      } else {
        // 倒转
        this.xuzhuanTag = this.xuzhuanTag - 90
      }
      this.showFlags = (this.xuzhuanTag % 360) === 0
      this.$refs.bigImgObj.style.transform = 'rotate(' + this.xuzhuanTag + 'deg)' // deg)后面绝对不能加分号, 否则旋转无效
    },
    setImgSize () {
      const isLogin = this.$store.state.globalObj.nowUserLoginState
      // 如果已经登录 则检查是否已经收藏  否则就不检查不然没意义
      if (isLogin) {
        // this.loadNotes(this.imgId) // 加载标签
      }

      this.showLoad = false
      this.imgH = this.$refs.bigImgObj.height
      this.imgW = this.$refs.bigImgObj.width
      setTimeout(() => {
        zoomAndDrag('bigImg', this)
        const oImg = this.$refs.bigImgObj
        oImg.className = 'onehand'
        const oParent = oImg.parentNode
        suitToImgPan(
          oParent.clientHeight,
          oParent.clientWidth,
          this.imgH,
          this.imgW,
          'bigImg',
          10,
          10
        )
      }, 100)
    },
    getSrcImg () {
      const label = null
      const level = null
      if (level !== null && level !== 'null') {
        this.label = level + '   ' + label
      } else {
        this.label = label
      }
      if (this.imgSrcLoadType === 0) {
        this.srcImgUrl = imgurl + 'samllimg/' + this.imgId + '/0'
      } else {
        this.srcImgUrl = imgurl + 'samllimg/' + this.imgId + '/0'
      }
    },
    showMask (imgId, imgInfo, tag) {
      this.imgId = imgId
      let kk = []
      kk = imgInfo.split(':')
      this.imgName = kk[0]
      this.isrc = kk[1]
      if (this.isrc != null && this.isrc.length > 0) {
        const arr = this.isrc.split('　')
        if (arr != null && arr.length === 3) {
          this.isrc1 = arr[0]
          this.isrc2 = arr[1]
          this.isrc3 = arr[2]
        }
      }
      this.idraw = kk[2]
      this.imark = kk[3]
      // 读取原始图片
      if (tag === '1') {
        this.imgSrcLoadType = 1
      } else {
        this.imgSrcLoadType = 0
      }
      this.getSrcImg()
      this.showModal = true
      this.showLoad = true
      const imgUrl = '/md/front/paid/img/view/'
      this.imageSrc = imgUrl + imgId + '/' + encodeURI(imgInfo)
    },
    checkHasOwnThisImgFun () { //  加载万立马查看是否有 把该图片加入收藏夹
      const isLogin = this.$store.state.globalObj.nowUserLoginState
      // 如果已经登录 则检查是否已经收藏  否则就不检查不然没意义
      if (isLogin) {
        // 只要鼠标移动到控制按钮div里面就判断是否已收藏当前图片
        this.axios.post('/md/front/additional/collection/check', this.$stringify({ imgId: this.imgId })).then(res => {
          if (res.status === 200) {
            this.ownThisImg = res.data
          }
        })
      }
    }
  },
  computed: {
    imageModalState () {
      return this.$store.state.events.showImageModalState
    }
  },
  watch: {
    imageModalState () {
      const imgId = this.$store.state.globalObj.showImgID
      const imgInfo = this.$store.state.globalObj.showImgInfo
      const tag = null
      this.showMask(imgId, imgInfo, tag) // 监听打开全屏大图
    }
  },
  components: {
    // notePan: notePan
  }
}
</script>

<style scoped>
#iip_name {
  font-weight: 600;
}
.iip_right_t {
  line-height: 25px;
}
.titlespan {
  padding-left: 30px;
}
#imgInfoCanV {
  position: absolute;
  bottom: 30px;
  left: 10px;
  width: 330px;
  height: 300px;
  z-index: 1001;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;

  background-color: rgba(96, 98, 102, 0.8);
}
#imgInfoPan {
  width: 100%;
  height: 100%;
  padding: 10px 10px 0 10px;
  color: #fff;
  font-size: 14px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#lbinfo {
  color: #fff;
  font-weight: 500;
}

.infoDiv {
  width: 90%;
  margin-bottom: 6px;
}

#iip1 {
  height: 150px;
  display: flex;
  flex-direction: row;
}

#iip_left {
  width: auto;
  text-align: center;
  height: 100%;
  padding-top: 0px;
  overflow: hidden;
  display: inline-block;
}

#iip_left img {
  height: 100%;
}

#iip_right {
  min-width: 190px;
  display: inline-block;
  height: 100%;
  padding-left: 20px;
}

.flag {
  position: absolute;
}
#flags {
  display: block;
  width: 50px;
  height: auto;
  z-index: 2000;
  background-color: transparent;
  position: absolute;
  top: 20px;
  left: 10px;
}

#flags li {
  color: red;
  font-size: 25px;
  cursor: pointer;
}
.gaoliang {
  -webkit-filter: brightness(200%); /* Chrome, Safari, Opera */
  filter: brightness(200%);
}
.huidu {
  -webkit-filter: grayscale(80%); /* Chrome, Safari, Opera */
  filter: grayscale(80%);
}
.fanse {
  -webkit-filter: hue-rotate(90deg); /* Chrome, Safari, Opera */
  filter: hue-rotate(90deg);
}
.duibidu {
  -webkit-filter: contrast(200%); /* Chrome, Safari, Opera */
  filter: contrast(200%);
}

.dropbtn {
  color: white;
  font-size: 24px;
  border: none;
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #000;
  width: 100px;
  font-size: 16px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  -moz-border-radius: 10px; /* Gecko browsers */
  -webkit-border-radius: 10px; /* Webkit browsers */
  border-radius: 10px; /* W3C syntax */
  padding: 8px 0 8px 0;
}

.dropdown-content a {
  color: #fff;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: grey;
}

.dropdown:hover .dropdown-content {
  display: block;
  bottom: 20px;
}

.dropdown :hover .dropbtn {
  background-color: #3e8e41;
}

.el-image-viewer__actions__inner i {
  cursor: pointer;
  font-size: 24px;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}
.mask_plus {
  background-color: rgb(0, 0, 0);
  opacity: 0.7;
}

#img_pan {
  z-index: 1000;
}

#mask_close {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 30px;
  color: #fff;
  font-weight: 800;
  opacity: 1;
  z-index: 1002;
  cursor: pointer;
  font-size: 40px;
}

#img_loading {
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  text-align: center;
  vertical-align: middle;
}

#img_loading img {
  margin-top: calc((100vh - 100px) / 2);
}

#imgPan {
  z-index: 1000;
  width: 100%;
  height: 100%;
  position: fixed; /* 不写这条  右键获取总是被 mask_plus 覆盖*/
}

#toolPan {
  position: absolute;
  z-index: 1010;
}
</style>
